export default __webpack_public_path__ + "static/media/hht1_ep2_minisitcom_02.f61ce54a.png";